module.exports = __webpack_public_path__ + "img/ribbon.bf2d13f1.svg";